<template>

  <div class="pane-box">

    <div class="pane-label">
      <div></div>{{ label }} <span style="margin-left: 15px;" v-if="label == '矫治方案'">
        总计: <span style="color: #5E8EFC;">{{ orthodonticsData.bracesCount }}</span> 副 （需补缴 <span
          style="color: #5E8EFC;">{{ orthodonticsData.addPrice }}</span> 元）</span>
    </div>
    <div class="pane-download" v-for="(item, index) in dataList" :key="index" v-show="label != 'CNC制造文件'">

      <div class="down-file-wrap">

        <div class="down-file">
          <div v-if="isJson">.{{ getFileType(item.url) }}</div>
          <div v-else>.{{ getFileType(item) }}</div>
        </div>
        <div class="down-file-des">
          <a href="javascript:;" @click="selOpenFile(index, item)"
            :style="['ppt', 'pptx', 'ppsx', 'ppsm', 'pot', 'potm', 'pdf', 'ppt', 'mp4', 'stl'].includes(item.name.substring(item.name.lastIndexOf('.') + 1)) ? '' : 'color:#606266;'">
            {{ item.name }}
          </a>
        </div>
      </div>
      <div class="down-button" @click="downFile(item.url, item.name)">
        <i class="el-icon-download"></i>
      </div>

    </div>
    <div v-show="label == 'CNC制造文件'">

      <div class="pane-download" v-for="(item, index) in dataList" :key="index">

        <div class="down-file-wrap">

          <div class="down-file">
            <div v-if="isJson">.{{ getFileType(item.url) }}</div>
            <div v-else>.{{ getFileType(item) }}</div>
          </div>
          <div class="down-file-des"
            v-if="(servCataId == '1010698' || servCataId == '1010699') && common.serv.get(servCataId).isDesignData === '0'">
            <a href="javascript:;" @click="toPdf(index)" v-if="isJson">{{ item.name }}</a>
            <a href="javascript:;" @click="toPdf(index)" v-else>{{ renameFileName(item) + '_' + index + '.' +
              getFileType(item) }}</a>
          </div>
          <div class="down-file-des">
            <a v-if="item.name.substring(item.name.lastIndexOf('.')+1)=='stl'" @click="to3dModel">{{ item.name }}</a>
            <label v-else-if="isJson">{{ item.name }}</label>
          </div>
        </div>
        <div class="down-button" @click="downFile(item.url, item.name)" v-if="isJson">
          <i class="el-icon-download"></i>
        </div>
        <div class="down-button" @click="downFile(item, renameFileName(item) + '_' + index + '.' + getFileType(item))"
          v-else>
          <i class="el-icon-download"></i>
        </div>

      </div>
    </div>

    <div class="pane-download" v-if="dataList.length <= 0">

      <div class="no-file">
        <i class="el-icon-warning-outline"></i>
        <span>暂未上传</span>
      </div>

    </div>
  </div>

</template>

<script>
import {
  mapState
} from 'vuex'
export default {
  props: {
    label: {
      type: String,
      default: null
    },
    fileList: {
      type: String,
      default: null
    },
    dataSheet: {
      type: String,
      default: null
    },
    servOrderId: {
      type: String,
      default: null
    },
    servCataId: {
      type: String,
      default: null
    },
    isDown: {
      type: Boolean,
      default: true
    },
    report: {
      type: String,
    },
    guide: {
      type: String,
    },
    orthodonticsData:{
      type:Object,
      default: null
    },
  },
  data() {
    return {
      dataList: [],
      isView: true,
      isJson: false,
    }
  },
  computed: {
    ...mapState(['common'])
  },
  methods: {
    // 匹配对应预览文件
    selOpenFile(index,item){
      let id = this.servCataId;
      let suffix = item.name.substring(item.name.lastIndexOf('.')+1)
      // 两类导板回传文件为pdf文件
      if(['1010698','1010699'].includes(id)){
        this.toPdf(index);
      }else if(suffix == 'mp4'||['矫治方案','模拟视频'].includes(this.label)){
        this.toLink(item);
      }else if(suffix == 'stl'){
        this.to3dModel(index);
      }
    },
    downFile(url, fileName) {
      var loading = this.$loading({
        text: '正在下载，已下载 0%'
      });
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      // 监听进度事件
      xhr.onprogress = function (e) {
        if (e.lengthComputable) {
          const percentComplete = (e.loaded / e.total) * 100;
          loading.setText('正在下载，已下载' + percentComplete.toFixed(2) + '%')
          if (percentComplete == 100) {
            loading.close();
          }
          // 更新你的加载指示器
        }
      }
      xhr.onload = function () {
        if (this.status === 200) {
          const blob = this.response;
          const blobUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = blobUrl;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(blobUrl);
          // 隐藏或重置加载指示器
        }
      }
      xhr.onerror = function () {
        console.error('Error downloading the file.');
        // 处理错误，隐藏或重置加载指示器
      }
      xhr.send();
    },
    to3dModel() {
      let routeUrl = this.$router.resolve({ path: '/3Dmodel', query: { orderId: this.servOrderId } })
      window.open(routeUrl.href, '_blank');
    },
    toPdf(index) {
      this.$router.push({
        name: 'pdfPreview',
        params: {
          name: this.label,
          url: this.label == '种植导板手术规划报告(PDF格式)' ? JSON.parse(this.report)[index].url : JSON.parse(this.guide)[index].url
        }
      })
    },
    // 正畸中矫治方案/模拟视频两种预览方式
    toLink(item){
      if(this.label == '矫治方案'){
          const officeOnlineUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(item.url)}`;
          window.open(officeOnlineUrl, '_blank');
      } else if (this.label == '模拟视频') {
        let videoUrl = item.url;
        const htmlContent = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Video Player</title>
        </head>
          <style>
            body {
              margin: 0;
              padding: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100vh;
              background-color: #000;
            }
            video {
              width: 100%;
              height: auto;
              max-width: 100%;
              max-height: 100%;
            }
          </style>
        <body>
          <video controls>
            <source src="${videoUrl}" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </body>
        </html>
      `;

        const blob = new Blob([htmlContent], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      }
    },
    handleFile() {
      // 单独处理无牙颌的第二个上传入口的CBCT文件
      if (this.label == 'CBCT数据' && this.dataSheet) {
        let sheet = JSON.parse(this.dataSheet)
        sheet.forEach(ele => {
          this.dataList.push(ele)
        });
      }
    }
  },
  mounted() {
    try {
      let temp = JSON.parse(this.fileList)
      this.isJson = true
    } catch (e) {
      this.isJson = false
    }
    if (this.fileList!=''&&this.fileList!=null&&this.fileList.includes("/123456/")) {
      this.dataList.push(temp)
    } else {
      if (this.isJson == true) {
        let temp = JSON.parse(this.fileList)
        this.dataList = temp ? temp : [];
      } else {
        this.dataList = this.fileList != 0 ? this.fileList.split(",") : [];
      }
    }
    if (this.label != '种植导板手术规划报告(PDF格式)' && this.label != '器械钻针使用流程及注意事项(PDF格式)') {
      this.isView = false
    }
    this.handleFile();
  }
}
</script>

<style lang="scss">
@import "../../../assets/style/mixin";

.pane-box {}

.pane-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  line-height: 32px;

  div {
    width: 5px;
    height: 14px;
    border-radius: 2px;
    background-color: #00a5d5;
    margin-right: 10px;
  }

}

.pane-download {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: #ececec;
  border-radius: 5px;
  padding: 10px 15px;
  margin: 5px 0;
}

.down-file-wrap {
  display: flex;
}

.down-file-des {
  display: flex;
  flex-direction: column;
  padding: 5px 20px;

  a {
    flex: 1;
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: 500;
  }

  label {
    flex: 1;
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: 500;
  }
}

.down-file {
  height: 60px;
  width: 60px;
  background-image: url(/static/images/file.png);
  background-size: 50px 60px;
  background-repeat: no-repeat;
  background-position: center;

  div {
    width: 100%;
    color: #f7f7f7;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    margin-top: 22px;
  }

}

.down-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 26px;
  width: 38px;
  height: 38px;

  &:hover {
    color: #00a5d5;
    border-color: #00a5d5;
    background-color: #E4E7ED;
  }
}

.no-file {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 28px;

  i {
    font-size: 15px;
  }

  span {
    font-size: 13px;
    margin-left: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// detailData.vue?4a5b6612